import $ from 'jquery';

export default class Voucher {
    constructor(e) {
        this.$e = $(e);
        if (this.$e.length) this.init();
    }
    init() {
        this.$input = this.$e.find('.voucher__value input');
        this.$btn = this.$e.find('.btn.btn--cart');
        this.$input.on('input', ()=>{
            this.$btn.attr('href', this.$input.attr('data-href') + this.$input.val());
        });
        this.$input.trigger('input');
    }
}